import { render, staticRenderFns } from "./DisputeHistory.vue?vue&type=template&id=3d1d1a6c&scoped=true"
import script from "./DisputeHistory.vue?vue&type=script&lang=js"
export * from "./DisputeHistory.vue?vue&type=script&lang=js"
import style0 from "./DisputeHistory.vue?vue&type=style&index=0&id=3d1d1a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d1a6c",
  null
  
)

export default component.exports